import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PageContentWrapper from "../../components/mui/app/pageContentWrapper/pageContentWrapper";
import {PAGE_APPLICATIONS} from "../../locales/pages/namespaces";
import Form from "../../components/custom/initialPasswordForm/form";
import {useParams} from "react-router-dom";
import LanguageSelect from "../../components/app/languageSelect/languageSelect";
import React from "react";
import Images from "../../assets";


const InitialChangePass = () => {
    const {campaign} = useParams()
    const { t } = useTranslation(PAGE_APPLICATIONS);


    return (
        <PageContentWrapper>
            <Box
                sx={{
                    pt:0,
                    width: "100%",
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    px: 2
                }}
            >

                <Box
                    sx={{
                        width: 500,
                        minHeight: 440,
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "30px",
                        overflow: "hidden",
                        boxShadow: "0px 40px 40px rgba(0,0,0,0.4)",
                        position: "relative",
                        backdropFilter: "blur(10px)"
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            height: 108,
                            background: "#FFFFFF",
                            borderRadius: "30px 30px 0 0",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            boxShadow: "0px 20px 40px rgba(0,0,0,0.48)",
                            zIndex: 2,
                        }}
                    >
                        <Box
                            component="img"
                            src={Images.bigLogoNew}
                            alt="logo"
                            sx={{
                                ml:2,
                                display:'flex',
                                width: "50%",
                                height:'40%'
                            }}
                        />
                        <LanguageSelect color={'#000000'}/>
                    </Box>

                    <Box
                        sx={{
                            flex: 1,
                            width: "100%",
                            background:
                                "linear-gradient(180deg, rgba(255,255,255,0.01) 50%, rgba(216,216,216,0.01) 100%)",
                            backdropFilter: "blur(10px)",
                            px: 4,
                            py: 5,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            color: "#fff",
                        }}
                    >

                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: 22,
                                textAlign: "center",
                            }}
                        >
                            {t("Reset Password")}
                        </Typography>
                        <Form />
                    </Box>
                </Box>
            </Box>
        </PageContentWrapper>
    );
};

export default InitialChangePass;
